<template>
  <div class="project-section">
    <header class="header project-section-1">
      <h1>Plans to Perfection </h1>
        <h1>Projects Completed</h1>
    </header>
    <div class="container">
      <div class="d-flex flex-row custom-card rounded-5">
        <swiper
            class="swiper"
            :modules="modules"
            :space-between="1"
            :slides-per-view="1"
            :free-mode="true"
            :autoplay="{
              delay: 1000,
              disableOnInteraction: false
            }"
            :breakpoints="{
                320: {
                  slidesPerView: 1, // Very small screens
                  spaceBetween: 10
                },
                576: {
                  slidesPerView: 1, 
                  spaceBetween: 1
                },
                768: {
                  slidesPerView: 2, // Medium screens (md)
                  spaceBetween: 1
                },
                992: {
                  slidesPerView: 2, // Large screens (lg)
                  spaceBetween: 1
                },
                1200: {
                  slidesPerView: 2, // Extra large screens (xl)
                  spaceBetween: 1
                },
                1400: {
                  slidesPerView: 3, // Very large screens
                  spaceBetween: 1
                }
              }"
          >
            <swiper-slide class="slide" v-for="(image, index) in imagesData" :key="index">
              <div class="">
                <div class="card text-center rounded-5 border-light">
                  <img :src="image.src" class="card-img-top rounded-5 mx-auto" :alt="image.alt">
                </div>
            </div>
            </swiper-slide>
        </swiper>
      </div>
    
      <div class="content project-section-3 center-content">
        <h3>Vangani Water Supply Scheme, Thane</h3>
        <!-- <p>Pratima construction and consultant have completed projects:</p> -->
        <ul>
          <li>
            Jackwell, water treatment plant, elevated service reserve wire
          </li>
          <li>
            Duck tile iron distribution system network
          </li>
          <li>
            Scheme commission 2019
          </li>
          <li>
            Submitted by P.L Adke
          </li>
        </ul>
        <div class="line mt-5"></div>
      </div>
    </div>
    <div class="container">
      <div class="d-flex flex-row custom-card rounded-5">
        <swiper
            class="swiper"
            :modules="modules"
            :space-between="1"
            :slides-per-view="1"
            :free-mode="true"
            :autoplay="{
              delay: 1000,
              disableOnInteraction: false
            }"
            :breakpoints="{
                320: {
                  slidesPerView: 1, // Very small screens
                  spaceBetween: 10
                },
                576: {
                  slidesPerView: 1, 
                  spaceBetween: 1
                },
                768: {
                  slidesPerView: 2, // Medium screens (md)
                  spaceBetween: 1
                },
                992: {
                  slidesPerView: 2, // Large screens (lg)
                  spaceBetween: 1
                },
                1200: {
                  slidesPerView: 2, // Extra large screens (xl)
                  spaceBetween: 1
                },
                1400: {
                  slidesPerView: 3, // Very large screens
                  spaceBetween: 1
                }
              }"
          >
            <swiper-slide class="slide" v-for="(image, index) in imagesData" :key="index">
              <div class="">
                <div class="card text-center rounded-5 border-light">
                  <img :src="image.src" class="card-img-top rounded-5 mx-auto" :alt="image.alt">
                </div>
            </div>
            </swiper-slide>
        </swiper>
      </div>
    
      <div class="content project-section-3 center-content">
        <h3>Kasara Water Supply Scheme , Thane</h3>
        <!-- <p>Pratima construction and consultant have completed projects:</p> -->
        <ul>
          <li>
            Strengthening of earthen dam
          </li>
          <li>
            Jack with V.T. pump and water treatment plant
          </li>
          <li>
            ESR and distribution network system
          </li>
          <li>
            Steam completed and commission 2019
          </li>
          <li>
            Submitted by P.L Adke
          </li>
        </ul>
        <div class="line mt-5"></div>
      </div>
    </div>
    <div class="container">
      <div class="d-flex flex-row custom-card rounded-5">
        <swiper
            class="swiper"
            :modules="modules"
            :space-between="1"
            :slides-per-view="1"
            :free-mode="true"
            :autoplay="{
              delay: 1000,
              disableOnInteraction: false
            }"
            :breakpoints="{
                320: {
                  slidesPerView: 1, // Very small screens
                  spaceBetween: 10
                },
                576: {
                  slidesPerView: 1, 
                  spaceBetween: 1
                },
                768: {
                  slidesPerView: 2, // Medium screens (md)
                  spaceBetween: 1
                },
                992: {
                  slidesPerView: 2, // Large screens (lg)
                  spaceBetween: 1
                },
                1200: {
                  slidesPerView: 2, // Extra large screens (xl)
                  spaceBetween: 1
                },
                1400: {
                  slidesPerView: 3, // Very large screens
                  spaceBetween: 1
                }
              }"
          >
            <swiper-slide class="slide" v-for="(image, index) in imagesData" :key="index">
              <div class="">
                <div class="card text-center rounded-5 border-light">
                  <img :src="image.src" class="card-img-top rounded-5 mx-auto" :alt="image.alt">
                </div>
            </div>
            </swiper-slide>
        </swiper>
      </div>
    
      <div class="content project-section-3 center-content">
        <h3>Baramati MIDC Water Supply, Baramati</h3>
        <!-- <p>Pratima construction and consultant have completed projects:</p> -->
        <ul>
          <li>
            Water supply from Ujjani Dam
          </li>
          <li>
            Jack well and approach bund
          </li>
          <li>
            M.S. pipeline K
          </li>
          <li>
            Submitted by P.L Adke
          </li>
        </ul>
        <div class="line mt-5"></div>
      </div>
    </div>
    <div class="container">
      <div class="d-flex flex-row custom-card rounded-5">
        <swiper
            class="swiper"
            :modules="modules"
            :space-between="1"
            :slides-per-view="1"
            :free-mode="true"
            :autoplay="{
              delay: 1000,
              disableOnInteraction: false
            }"
            :breakpoints="{
                320: {
                  slidesPerView: 1, // Very small screens
                  spaceBetween: 10
                },
                576: {
                  slidesPerView: 1, 
                  spaceBetween: 1
                },
                768: {
                  slidesPerView: 2, // Medium screens (md)
                  spaceBetween: 1
                },
                992: {
                  slidesPerView: 2, // Large screens (lg)
                  spaceBetween: 1
                },
                1200: {
                  slidesPerView: 2, // Extra large screens (xl)
                  spaceBetween: 1
                },
                1400: {
                  slidesPerView: 3, // Very large screens
                  spaceBetween: 1
                }
              }"
          >
            <swiper-slide class="slide" v-for="(image, index) in imagesData" :key="index">
              <div class="">
                <div class="card text-center rounded-5 border-light">
                  <img :src="image.src" class="card-img-top rounded-5 mx-auto" :alt="image.alt">
                </div>
            </div>
            </swiper-slide>
        </swiper>
      </div>
    
      <div class="content project-section-3 center-content">
        <h3>Yavatmal Water Supply Scheme, Yavatmal</h3>
        <!-- <p>Pratima construction and consultant have completed projects:</p> -->
        <ul>
          <li>
            Jack well, intake well and approach bridge
          </li>
          <li>
            Pumping station approach Road and D.I. pipeline
          </li>
          <li>
            HDPE distribution network
          </li>
          <li>
            Submitted by P.L Adke
          </li>
        </ul>
        <div class="line mt-5"></div>
      </div>
    </div>
    <div class="container">
      <div class="d-flex flex-row custom-card rounded-5">
        <swiper
            class="swiper"
            :modules="modules"
            :space-between="1"
            :slides-per-view="1"
            :free-mode="true"
            :autoplay="{
              delay: 1000,
              disableOnInteraction: false
            }"
            :breakpoints="{
                320: {
                  slidesPerView: 1, // Very small screens
                  spaceBetween: 10
                },
                576: {
                  slidesPerView: 1, 
                  spaceBetween: 1
                },
                768: {
                  slidesPerView: 2, // Medium screens (md)
                  spaceBetween: 1
                },
                992: {
                  slidesPerView: 2, // Large screens (lg)
                  spaceBetween: 1
                },
                1200: {
                  slidesPerView: 2, // Extra large screens (xl)
                  spaceBetween: 1
                },
                1400: {
                  slidesPerView: 3, // Very large screens
                  spaceBetween: 1
                }
              }"
          >
            <swiper-slide class="slide" v-for="(image, index) in imagesData" :key="index">
              <div class="">
                <div class="card text-center rounded-5 border-light">
                  <img :src="image.src" class="card-img-top rounded-5 mx-auto" :alt="image.alt">
                </div>
            </div>
            </swiper-slide>
        </swiper>
      </div>
    
      <div class="content project-section-3 center-content">
        <h3>Ashoka Industrial Park Water Supply Scheme,Gonde, Igatpuri</h3>
        <!-- <p>Pratima construction and consultant have completed projects:</p> -->
        <ul>
          <li>
            Intech channel
          </li>
          <li>
            Jack and D.I. pipeline from Mukhe Dam
          </li>
          <li>
            What is supply to Ashoka industrial Park
          </li>
          <li>
            Submitted by P.L Adke
          </li>
        </ul>
        <div class="line mt-5"></div>
      </div>
    </div>

    <div class="container">
      <div class="d-flex flex-row custom-card rounded-5">
        <swiper
            class="swiper"
            :modules="modules"
            :space-between="1"
            :slides-per-view="1"
            :free-mode="true"
            :autoplay="{
              delay: 1000,
              disableOnInteraction: false
            }"
            :breakpoints="{
                320: {
                  slidesPerView: 1, // Very small screens
                  spaceBetween: 10
                },
                576: {
                  slidesPerView: 1, 
                  spaceBetween: 1
                },
                768: {
                  slidesPerView: 2, // Medium screens (md)
                  spaceBetween: 1
                },
                992: {
                  slidesPerView: 2, // Large screens (lg)
                  spaceBetween: 1
                },
                1200: {
                  slidesPerView: 2, // Extra large screens (xl)
                  spaceBetween: 1
                },
                1400: {
                  slidesPerView: 3, // Very large screens
                  spaceBetween: 1
                }
              }"
          >
            <swiper-slide class="slide" v-for="(image, index) in imagesData" :key="index">
              <div class="">
                <div class="card text-center rounded-5 border-light">
                  <img :src="image.src" class="card-img-top rounded-5 mx-auto" :alt="image.alt">
                </div>
            </div>
            </swiper-slide>
        </swiper>
      </div>
    
      <div class="content project-section-3 center-content">
        <h3>Dindori MIDC Water Supply, Nashik</h3>
        <!-- <p>Pratima construction and consultant have completed projects:</p> -->
        <ul>
          <li>
            Water supply from Plkhed Dam
          </li>
          <li>
            Water treatment plant
          </li>
          <li>
            M.S. pipeline RCC elevated service reservewire
          </li>
          <li>
            Submitted by P.L Adke
          </li>
        </ul>
        <div class="line mt-5 mb-5"></div>
      </div>
    </div>

    <header class="header project-section-1 mt-5">
      <h1>Plans to Perfection </h1>
        <h1>On Going Projects</h1>
    </header>
    <div class="container project-section-4">
      <div class="d-flex flex-row custom-card rounded-5">
        <swiper
            class="swiper"
            :modules="modules"
            :space-between="1"
            :slides-per-view="1"
            :free-mode="true"
            :autoplay="{
              delay: 1000,
              disableOnInteraction: false
            }"
            :breakpoints="{
                320: {
                  slidesPerView: 1, // Very small screens
                  spaceBetween: 10
                },
                576: {
                  slidesPerView: 1, 
                  spaceBetween: 1
                },
                768: {
                  slidesPerView: 2, // Medium screens (md)
                  spaceBetween: 1
                },
                992: {
                  slidesPerView: 3, // Large screens (lg)
                  spaceBetween: 1
                },
                1200: {
                  slidesPerView: 3, // Extra large screens (xl)
                  spaceBetween: 1
                },
                1400: {
                  slidesPerView: 4, // Very large screens
                  spaceBetween: 1
                }
              }"
          >
            <swiper-slide class="slide" v-for="(image, index) in projectData" :key="index">
              <div class="">
                <div class="card text-center rounded-5 border-light">
                  <img :src="image.src" class="card-img-top rounded-5 mx-auto" :alt="image.alt">
                </div>
            </div>
            </swiper-slide>
        </swiper>
      </div>
    
      <div class="content center-content project-section-5">
        <h3>Shirasgaon Water Supply scheme, Mukhada Palghar</h3>
        <p>network of distribution pipeline for villages around</p>
      </div>
    </div>

    <div class="container project-section-4">
      <div class="d-flex flex-row custom-card rounded-5">
        <swiper
            class="swiper"
            :modules="modules"
            :space-between="1"
            :slides-per-view="1"
            :free-mode="true"
            :autoplay="{
              delay: 1000,
              disableOnInteraction: false
            }"
            :breakpoints="{
                320: {
                  slidesPerView: 1, // Very small screens
                  spaceBetween: 10
                },
                576: {
                  slidesPerView: 1, 
                  spaceBetween: 1
                },
                768: {
                  slidesPerView: 2, // Medium screens (md)
                  spaceBetween: 1
                },
                992: {
                  slidesPerView: 3, // Large screens (lg)
                  spaceBetween: 1
                },
                1200: {
                  slidesPerView: 3, // Extra large screens (xl)
                  spaceBetween: 1
                },
                1400: {
                  slidesPerView: 4, // Very large screens
                  spaceBetween: 1
                }
              }"
          >
            <swiper-slide class="slide" v-for="(image, index) in projectData" :key="index">
              <div class="">
                <div class="card text-center rounded-5 border-light">
                  <img :src="image.src" class="card-img-top rounded-5 mx-auto" :alt="image.alt">
                </div>
            </div>
            </swiper-slide>
        </swiper>
      </div>
    
      <div class="content center-content project-section-5">
        <h3>Natepute Nagar Panchayat Water Supply Scheme, Solapur</h3>
        <p>Elevated service reservewire for Shikshak colony</p>
      </div>
    </div>

    <div class="container project-section-4">
      <div class="d-flex flex-row custom-card rounded-5">
        <swiper
            class="swiper"
            :modules="modules"
            :space-between="1"
            :slides-per-view="1"
            :free-mode="true"
            :autoplay="{
              delay: 1000,
              disableOnInteraction: false
            }"
            :breakpoints="{
                320: {
                  slidesPerView: 1, // Very small screens
                  spaceBetween: 10
                },
                576: {
                  slidesPerView: 1, 
                  spaceBetween: 1
                },
                768: {
                  slidesPerView: 2, // Medium screens (md)
                  spaceBetween: 1
                },
                992: {
                  slidesPerView: 3, // Large screens (lg)
                  spaceBetween: 1
                },
                1200: {
                  slidesPerView: 3, // Extra large screens (xl)
                  spaceBetween: 1
                },
                1400: {
                  slidesPerView: 4, // Very large screens
                  spaceBetween: 1
                }
              }"
          >
            <swiper-slide class="slide" v-for="(image, index) in projectData" :key="index">
              <div class="">
                <div class="card text-center rounded-5 border-light">
                  <img :src="image.src" class="card-img-top rounded-5 mx-auto" :alt="image.alt">
                </div>
            </div>
            </swiper-slide>
        </swiper>
      </div>
    
      <div class="content center-content project-section-5">
        <h3>Otur Water Supply Scheme, PUNE</h3>
        <p>Intake well , jack well approach bridge whiter treatment plant. 
          Elevated service reservewire DI and HDPE distribution network along with rising main</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'; // Import Swiper Vue components
import 'swiper/css'; // Import Swiper base styles
import 'swiper/css/pagination'; // Import Swiper pagination styles
import { Pagination, FreeMode, Autoplay } from 'swiper/modules'; // Import Swiper modules

export default {
  name: "ProjectsPage",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      modules: [Pagination, FreeMode, Autoplay], // Include the Autoplay module here
      imagesData: [
        { src: require('@/assets/home-pg-img/gallary-mobile/gallery1.jpeg'), alt: "Water treatment plant" },
        { src: require('@/assets/home-pg-img/gallary-mobile/gallery2.jpg'), alt: "Water supply infrastructure" },
        { src: require('@/assets/home-pg-img/gallary-mobile/gallery3.jpeg'), alt: "Water supply infrastructure" },

      ],
      projectData: [
        { src: require('@/assets/home-pg-img/gallary-mobile/gallery1.jpeg'), alt: "Water treatment plant" },
        { src: require('@/assets/home-pg-img/gallary-mobile/gallery2.jpg'), alt: "Water supply infrastructure" },
        { src: require('@/assets/home-pg-img/gallary-mobile/gallery4.jpeg'), alt: "Water supply infrastructure" },
        { src: require('@/assets/home-pg-img/gallary-mobile/gallery3.jpeg'), alt: "Water supply infrastructure" },
      ],
      teamData:[
        {
          image: require("@/assets/images/about-us-images/Photo team.jpg"), // Replace with actual image path
          alt: "Payal Gade",
          name: "Payal Gade",
          designation: "UI/UX Designer"
        },
        {
          image: require("@/assets/images/about-us-images/photo 1 team.jpg"), // Replace with actual image path
          alt: "Payal Gade",
          name: "Payal Gade",
          designation: "UI/UX Designer"
        },
        {
          image: require("@/assets/images/about-us-images/Photo team.jpg"), // Replace with actual image path
          alt: "Payal Gade",
          name: "Payal Gade",
          designation: "UI/UX Designer"
        },
      ],
    };
  },
};
</script>

<style>
.project-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.project-section-1 {
  text-align: center;
  background: linear-gradient(90deg, #197dca 0%, #0c3e64 51.63%, #135d97 100%);
  font-weight: 700;
  border-radius: 20px;
  width: 100%;
  padding: 4vh 5vw; /* Adjust for responsiveness */
  box-sizing: border-box;
}

.project-section-1 h1 {
  font-size: clamp(24px, 6vw, 64px); /* Responsive font size */
  line-height: 1.3;
  letter-spacing: 0.07em;
  color: #fff;
  font-family: 'Archivo';
  padding: 0;
}

.project-section .card-img-top {
  width: 400px;
  height: 300px;
  border-radius: 25px;
}

.project-section .custom-card {
  margin-top: 5vh;
  height: auto; /* Let height adjust dynamically */
}

.project-section .swiper {
  width: 100%; /* Make swiper responsive */
  height: auto; /* Let height adjust dynamically */
}

.project-section .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}

.project-section .swiper-slide .card {
  max-height: 100%; /* Ensure it doesn’t overflow */
}

.project-section .swiper-pagination {
  top: 66vh; /* Avoid fixed positioning */
}

.project-section-3 {
  max-width: 63%; /* Set a flexible width for responsiveness */
  margin: 20px auto; /* Center the entire div horizontally */
  text-align: left; /* Align text to the left */
}

.project-section-3 h3 {
  font-size: clamp(24px, 2vw, 40px);
  text-align: left; /* Align the heading to the left */
  font-family: 'Inter';
  columns: #000;
  font-weight: 500;
}

.project-section-3 p {
  font-size: 16px;
  text-align: left; /* Align the paragraph to the left */
}

.project-section-3 ol {
  text-align: left; /* Left-align the list items */
  margin: 0 auto; /* Center the list itself within the parent width */
}

.project-section-3 li {
  font-weight: 500;
  font-size: clamp(14px, 2vw, 20px); /* Responsive font size */
  line-height: 187%;
  letter-spacing: 0.01em;
  font-family: 'Inter';
  margin-bottom: 5px;
  text-align: left; /* Ensure the list items are left-aligned */
}


.project-section .line {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto;
  width: 90%; /* Adjust to container width */
  max-width: 600px;
  height: 2px;
  background-color: #197DCA;
}

@media (max-width:991px) {
  .project-section .card-img-top{
    width: 324px;
    height: 285px;
  }

  .project-section-3{
    max-width: 93%;
  }

  .project-section-3 h3 {
    font-size: 30px;
  }
  .project-section-4 p{
    padding: 0vh 0vh !important;
  }
}


.project-section-4 .card-img-top{
  width: 286px;
  height: 254px;
}

.project-section-4 h3{
  font-weight: 500;
  font-size: 40px;
  line-height: 125%;
  color: #000;
  font-family: 'Inter';
  text-align: left;
}

.project-section-4 p{
  font-weight: 500;
  font-size: 20px;
  line-height: 125%;
  letter-spacing: 0.01em;
  text-align: left;
  font-family: 'Inter';
  padding: 0vh 0vh;
}

.project-section-5{
  max-width: 73%; /* Set a flexible width for responsiveness */
  margin: 46px auto; /* Center the entire div horizontally */
  text-align: left; /* Align text to the left */
}

@media (max-width:767px) {
  .project-section-4 h3{
    font-weight: 500;
    font-size: 24px;
    line-height: 125%;
    color: #000;
  }
  .project-section-4 p{
    font-weight: 400;
    font-size: 14px;  
  }

  .project-section-5{
    max-width: 56%;
  }
}

</style>
